"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabListTokens = void 0;
const Global_1 = require("../../DesignSystem/tokens/Global");
const DesignToken_1 = __importDefault(require("../../DesignSystem/types/DesignToken"));
const tabListBackgroundColor = new DesignToken_1.default({
    name: 'tabList-backgroundColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultSecondary,
        Global_1.globalTokens.oldTokens.colorBackgroundNeutralLight
    ]
});
const tabListBorderColor = new DesignToken_1.default({
    name: 'tabList-borderColor',
    parent: [Global_1.globalTokens.colorStrokeDefaultDefault, Global_1.globalTokens.oldTokens.colorBorderMain]
});
const tabListBorderWidth = new DesignToken_1.default({
    name: 'tabList-borderWidth',
    parent: [Global_1.globalTokens.borderWidthS, Global_1.globalTokens.oldTokens.borderWidthS]
});
exports.tabListTokens = {
    tabListBackgroundColor,
    tabListBorderColor,
    tabListBorderWidth
};
//# sourceMappingURL=TabList.js.map